export default function PrivacyPolicy() {
    return (
        <div
          style={{
            backgroundColor: "#f9fafb",
            color: "#1f2937",
            fontFamily: "sans-serif",
          }}
        >
          <div style={{ maxWidth: "64rem", margin: "0 auto", padding: "2rem" }}>
            <h1
              style={{
                fontSize: "2.25rem",
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: "3rem",
                color: "#2563eb",
              }}
            >
              NuGenesis Privacy Policy
            </h1>
    
            <section
              style={{
                marginBottom: "2.5rem",
                padding: "1.5rem",
                backgroundColor: "#ffffff",
                borderRadius: "0.75rem",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              }}
            >
              <h2
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  marginBottom: "1rem",
                  color: "#1f2937",
                }}
              >
                1. Introduction
              </h2>
              <p style={{ color: "#4b5563" }}>
                This Privacy Policy describes how NuGenesis collects, uses, and
                protects your information when using our mobile application.
              </p>
            </section>
    
            <section
              style={{
                marginBottom: "2.5rem",
                padding: "1.5rem",
                backgroundColor: "#ffffff",
                borderRadius: "0.75rem",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              }}
            >
              <h2
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  marginBottom: "1rem",
                  color: "#1f2937",
                }}
              >
                2. Information We Collect
              </h2>
              <p style={{ color: "#4b5563" }}>
                We may collect personal information including your name and email.
                Additionally, we may collect device information, usage data, and log
                information for app analytics.
              </p>
            </section>
    
            <section
              style={{
                marginBottom: "2.5rem",
                padding: "1.5rem",
                backgroundColor: "#ffffff",
                borderRadius: "0.75rem",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              }}
            >
              <h2
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  marginBottom: "1rem",
                  color: "#1f2937",
                }}
              >
                3. How We Use Your Information
              </h2>
              <p style={{ color: "#4b5563" }}>
                We use your information to provide and improve our services, ensure
                app security, communicate with you, and comply with legal
                obligations.
              </p>
            </section>
    
            <section
              style={{
                marginBottom: "2.5rem",
                padding: "1.5rem",
                backgroundColor: "#ffffff",
                borderRadius: "0.75rem",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              }}
            >
              <h2
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  marginBottom: "1rem",
                  color: "#1f2937",
                }}
              >
                4. Data Security
              </h2>
              <p style={{ color: "#4b5563" }}>
                We implement AI-powered security measures to protect your data from
                unauthorized access, alteration, or disclosure.
              </p>
            </section>
    
            <section
              style={{
                marginBottom: "2.5rem",
                padding: "1.5rem",
                backgroundColor: "#ffffff",
                borderRadius: "0.75rem",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              }}
            >
              <h2
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  marginBottom: "1rem",
                  color: "#1f2937",
                }}
              >
                5. Data Sharing
              </h2>
              <p style={{ color: "#4b5563" }}>
                We do not sell your personal data. We may share information with
                trusted third-party partners for service provision, legal
                compliance, or fraud prevention.
              </p>
            </section>
    
            <section
              style={{
                marginBottom: "2.5rem",
                padding: "1.5rem",
                backgroundColor: "#ffffff",
                borderRadius: "0.75rem",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              }}
            >
              <h2
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  marginBottom: "1rem",
                  color: "#1f2937",
                }}
              >
                6. Your Rights
              </h2>
              <p style={{ color: "#4b5563" }}>
                You have the right to access, update, or delete your personal
                information. Please contact us for any data-related requests.
              </p>
            </section>
    
            <section
              style={{
                marginBottom: "2.5rem",
                padding: "1.5rem",
                backgroundColor: "#ffffff",
                borderRadius: "0.75rem",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              }}
            >
              <h2
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  marginBottom: "1rem",
                  color: "#1f2937",
                }}
              >
                7. Changes to This Policy
              </h2>
              <p style={{ color: "#4b5563" }}>
                We may update this Privacy Policy periodically. Continued use of the
                app constitutes your acceptance of the changes.
              </p>
            </section>
    
            <section
              style={{
                marginBottom: "2.5rem",
                padding: "1.5rem",
                backgroundColor: "#ffffff",
                borderRadius: "0.75rem",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              }}
            >
              <h2
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  marginBottom: "1rem",
                  color: "#1f2937",
                }}
              >
                8. Contact Us
              </h2>
              <p style={{ color: "#4b5563" }}>
                If you have any questions about this Privacy Policy, please contact
                us at
                <a
                  href="mailto:inquiries@nugenesisou.com"
                  style={{ color: "#2563eb", textDecoration: "underline" }}
                >
                  inquiries@nugenesisou.com
                </a>
                .
              </p>
            </section>
          </div>
    
          <footer
            style={{ marginTop: "4rem", textAlign: "center", color: "#6b7280" }}
          >
            <p>&copy; 2025 NuGenesis. All rights reserved.</p>
          </footer>
        </div>
      );
  }
  